import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Directive({
  selector: '[hluSelectOnFocus]',
})
export class SelectOnFocusDirective implements OnInit, OnDestroy {
  private focusSubscription: Subscription;
  private inputNodeName = 'INPUT';

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    const nodeName = (this.el.nativeElement as HTMLElement).nodeName;
    if (nodeName !== this.inputNodeName) {
      throw new Error(
        `hluSelectOnFocus cannot be applied to a ${nodeName}. It can only be applied to <input> elements`
      );
    }
    this.focusSubscription = fromEvent(
      this.el.nativeElement,
      'focus'
    ).subscribe((event: any) => {
      event.target.select();
    });
  }

  ngOnDestroy(): void {
    if (this.focusSubscription) {
      this.focusSubscription.unsubscribe();
    }
  }
}
